import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText } from "vue"

const _hoisted_1 = { class: "select-wrapper" }
const _hoisted_2 = ["data-invalid"]
const _hoisted_3 = ["value"]
const _hoisted_4 = ["data-invalid"]

import { ref, watch } from "vue";
import { PhoneNumberUtil } from "google-libphonenumber";


export default /*#__PURE__*/_defineComponent({
  __name: 'PhoneInputComponent',
  props: {
  context: {
    type: Object,
    default: () => ({})
  }
},
  setup(__props) {

const props = __props;

const phoneUtil = PhoneNumberUtil.getInstance();



const inputInvalid = ref(false);

const countries = [
  { iso: "BW", code: "+267", name: "Botswana"},
  // { iso: "ZA", code: "+27", name: "South Africa" }
];

const phoneNumber = ref(''); // Phone number input
const selectedCountry = ref(countries[0].iso); // Default to first country

const handleCountryChange = () => {
  validatePhoneNumber();
}

const handlePhoneInput = () => {
  validatePhoneNumber();
}

const validatePhoneNumber = () => {
  const phoneInput = phoneNumber.value;
  const country = countries.find(c => c.iso === selectedCountry.value) || countries[0];

  const tmpPhoneNumber = country.code + phoneInput;

  if (!phoneInput || phoneInput.length < 2) {
    props.context.node.setErrors([]);
    inputInvalid.value = false;
    return;
  }

  try {
    const parsedPhoneNumber = phoneUtil.parseAndKeepRawInput(tmpPhoneNumber);
    const isValid = phoneUtil.isValidNumber(parsedPhoneNumber);

    if (isValid) {
      inputInvalid.value = false;
      props.context.node.setErrors([]);
      props.context.node.input(tmpPhoneNumber);
    } else {
      props.context.node.setErrors(["Invalid phone number"]);
      inputInvalid.value = true;
    }
  } catch (e) {
    props.context.node.setErrors(["Invalid phone number"]);
    inputInvalid.value = true;
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _withDirectives(_createElementVNode("select", {
        "data-invalid": inputInvalid.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedCountry).value = $event)),
        onChange: handleCountryChange,
        class: "block rounded-md px-5 pr-9 py-2 text-gray-900 shadow-sm placeholder:text-gray-400 ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-blaze-orange-600 sm:text-sm sm:leading-6 outline-0 formkit-invalid:ring-red-500"
      }, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(countries, (country) => {
          return _createElementVNode("option", {
            value: country.iso,
            key: country.iso
          }, _toDisplayString(`${country.iso} (${country.code})`), 9, _hoisted_3)
        }), 64))
      ], 40, _hoisted_2), [
        [_vModelSelect, selectedCountry.value]
      ])
    ]),
    _withDirectives(_createElementVNode("input", {
      type: "text",
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((phoneNumber).value = $event)),
      onInput: handlePhoneInput,
      "data-invalid": inputInvalid.value,
      class: "block flex-1 rounded-md px-3.5 py-2 text-gray-900 shadow-sm placeholder:text-gray-400 ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-blaze-orange-600 sm:text-sm sm:leading-6 outline-0 formkit-invalid:ring-red-500"
    }, null, 40, _hoisted_4), [
      [_vModelText, phoneNumber.value]
    ])
  ], 64))
}
}

})